import AddIcon from "@/components/icons/AddIcon";
import ArrowIcon from "@/components/icons/ArrowIcon";
import { modifyMenuTreeData, sanitizeUrl } from "@/helpers/category";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { ModalContext } from "@/pages/_app";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";

const MenuCategoryTree = ({ menuTreeData }) => {
  const [currentCategory, setCurrentCategory] = useState(null);
  const { query, locale } = useRouter();
  console.log("query", query);
  const [isShowChild, setIsShowChild] = useState(
    Array(menuTreeData?.length).fill(false)
  );

  const modalsCtx = useContext(ModalContext);
  useBodyScrollLock();
  const toggleSubCategory = (index) => {
    setIsShowChild((prev) => {
      const newVisibilityState = [...prev];
      newVisibilityState[index] = !newVisibilityState[index];
      return newVisibilityState;
    });
  };

  useEffect(() => {
    query?.url_key?.at(-1)?.includes(currentCategory) &&
      modalsCtx.dispatch({ type: "sidemenu" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <div className="pt-5 border-b">
      <a
        className="hover:text-gray-800 text-red-600 animate-pulse text-nowrap px-5 block pb-4 hidden"
        href="https://imgs.awahed.com/media/media/Ramadan-flyer2025.pdf"
        target="_blank"
      >
        {locale === "ar" ? "تصفح عروض رمضان" : "Browse Ramadan offers"}
      </a>
      {menuTreeData?.map((cat, i) => {
        const parentUrl = `${cat.url_key}`;
        const hasChildren = modifyMenuTreeData(cat?.children_data)?.length > 0;

        return (
          <div key={i}>
            <div
              onClick={() => {
                hasChildren && toggleSubCategory(i);
              }}
              className="flex items-center justify-between px-5 pb-3 cursor-pointer sm:pb-5"
            >
              <div>
                <Link
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentCategory(cat.url_key);
                    modalsCtx.dispatch({ type: "sidemenu" });
                  }}
                  href={sanitizeUrl(parentUrl)}
                  className={`uppercase text-sm ${
                    isShowChild[i]
                      ? "text-tertiary-800 font-bold"
                      : "font-medium"
                  } max-sm:text-xs`}
                >
                  {cat.name}
                </Link>
              </div>

              {hasChildren && <AddIcon className="size-2.5 sm:size-3.5" />}
            </div>

            {isShowChild[i] && (
              <SubMenu
                data={cat?.children_data}
                setCurrentCategory={setCurrentCategory}
                parentUrl={parentUrl}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MenuCategoryTree;

const SubMenu = ({ data, parentUrl, setCurrentCategory }) => {
  console.log("data", data);
  const { locale } = useRouter();
  const modalsCtx = useContext(ModalContext);
  const modifiedData = modifyMenuTreeData(data);
  const [isShowChild, setIsShowChild] = useState(
    Array(modifiedData?.length).fill(false)
  );

  const toggleSubCategory = (index) => {
    setIsShowChild((prev) => {
      const newVisibilityState = [...prev];
      newVisibilityState[index] = !newVisibilityState[index];
      return newVisibilityState;
    });
  };

  return (
    <div className={`${locale === "en" ? "pl-6 pr-6" : "pr-6 pl-6"} pb-4`}>
      {modifiedData?.map((sub, i) => {
        const childUrl = `${parentUrl}/${sub.url_key}`;
        const hasChildren = modifyMenuTreeData(sub?.children_data)?.length > 0;

        return (
          <div key={i}>
            <div
              onClick={() => {
                hasChildren && toggleSubCategory(i);
              }}
              className="flex items-center justify-between pb-4 cursor-pointer"
            >
              <Link
                href={sanitizeUrl(childUrl)}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentCategory(sub?.url_key);
                  modalsCtx.dispatch({ type: "sidemenu" });
                }}
                className={`text-zinc-500 text-xs  ${
                  isShowChild[i] ? "font-bold" : "font-medium"
                }`}
              >
                {sub.name}
              </Link>
              {hasChildren && (
                <ArrowIcon
                  className={`size-2 transition-all ${
                    locale === "ar" && "rotate-180"
                  } ${isShowChild[i] ? "rotate-90" : ""}`}
                />
              )}
            </div>
            {isShowChild[i] && (
              <SubMenu
                data={sub?.children_data}
                setCurrentCategory={setCurrentCategory}
                parentUrl={childUrl}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
